import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactSession } from "../../../../lib/secure_reactsession";
import { Text } from "../../../themes/userq/Text/Text";
import { Button } from "../../../themes/userq/Button/Button";
import { Icon } from "../../../themes/userq/Icon/Icon";
import { LoadingIcon } from "../../../themes/userq/Loader/loadingIcon";
import { savePrototypeTesterInterctions } from "../../../../services/test_result";
import { showToast, shuffle } from "../../../../lib/helpers";
import { savePrototypeResultQuestion } from "../../../../services/test_result";
import ExitTestModal from "../../dialog/exit_test_modal";
import { validateResultData } from "../../../../services/test_result";
import GlobalQuestion from "../../global-question";

export default function PrototypeTestFreeFlow({
    test,
    task,
    active_task,
    result,
    timeSpent,
    moveToNextTask,
    isPaidUser,
    onAlreadyTaken,
}) {
    const navigate = useNavigate();
    const location = useLocation();
    let user = ReactSession.get("user");

    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [loading, setLoading] = useState(false);
    const [getStarted, setGetStarted] = useState(true);
    const [prototypeTask, setPrototypeTask] = useState(task);
    const travelledPath = useRef([]);
    const currentNode = useRef(null);
    const currentNodeclickMapData = useRef([]);
    const clickMapData = useRef([]);
    const [taskTimeSpent, setTaskTimeSpent] = useState(0);
    const [questionsSidebarOpen, setQuestionsSidebarOpen] = useState(false);
    const nodeTimeSpent = useRef(0);

    const [isActiveQuestion, setActiveQuestion] = useState(null);
    const [totalQuestion, setTotalQuestion] = useState(0);
    const [QuestionArrayList, setQuestionArrayList] = useState([]);
    const [formValues, setFormValues] = useState({
        type: null,
        question_id: null,
        answer: "",
        option_id: [],
        is_optional: 0,
    });
    const [, setFormErrors] = useState({ error: "", error_class: "" });
    const [questionLoading, setQuestionLoading] = useState(false);
    const [questionArray, setQuestionArray] = useState([]);
    const [questionTimeSpend, setQuestionTimeSpend] = useState(0);
    const [, setLikertActive] = useState(false);
    const [, setOptions] = useState([]);
    const isActiveQuestionId = useRef(null);
    const isSkipped = useRef(0);
    const isOptional = useRef(false);
    const [, setPlaceholderProps] = useState({});
    const skippedCount = useRef(0);
    const logicalySkipped = useRef(0);
    const isTyping = useRef(false);
    const [, setLogicAdded] = useState(false);
    const nextButtonActive = useRef(false);
    const likertAttemptedSubQuestion = useRef(0);
    const otherOptionSelected = useRef(false);
    var questionType = "Survey";
    const questionsOpened = useRef(false);
    const [openExitTestModal, setOpenExitTestModal] = useState(false);
    const [isNoneOfTheAboveSelected] = useState(false);
    const queryAttr = "data-rbd-drag-handle-draggable-id";
    const [, setRankingOptions] = useState([]);

    const closeExitTestModal = (data) => {
        setOpenExitTestModal(false);
        if (data) {
            saveAbandonedTest();
            if (location.pathname.substr(1, 1) === "p") {
                navigate("/");
            } else {
                if (!ReactSession.get("token")) {
                    navigate("/tester/sign-in");
                } else {
                    navigate("/");
                }
            }
        }
    };

    const saveAbandonedTest = () => {
        const token = ReactSession.get("token");
        const data = new FormData();
        data.append("test_id", test && test.id);
        data.append("guest_token", ReactSession.get("guest_token"));
        data.append("validate", "abandoned");
        data.append("type", location.pathname.substr(1, 1));
        data.append("result_id", result && result.id);
        data.append("time_spent", timeSpent);

        setLoading(true);
        validateResultData(data, token).then((response) => {
            setLoading(false);

            if (response.success) {
                navigate("/");
            } else {
                navigate("/");
            }
        });
    };

    useEffect(() => {
        setSidebarOpen(true);
        setGetStarted(true);
        setPrototypeTask(task);
        setLoading(false);
        travelledPath.current = [];
        currentNodeclickMapData.current = [];
        clickMapData.current = [];
        currentNode.current = null;

        setTaskTimeSpent(0);
        setQuestionTimeSpend(0);
        setQuestionsSidebarOpen(false);
        questionsOpened.current = false;
        setQuestionArray([]);
        loadQuestions();
    }, [active_task, task]);

    useEffect(() => {
        function tickTime() {
            nodeTimeSpent.current = nodeTimeSpent.current + 1;

            setTaskTimeSpent((prevSeconds) => prevSeconds + 1);
            setQuestionTimeSpend((prevSeconds) => prevSeconds + 1);
        }
        let timeData = setInterval(() => tickTime(), 1000);

        return () => clearInterval(timeData);
    }, []);

    const saveTesterInteraction = (travelledPath) => {
        setLoading(true);

        clickMapData.current.push({
            node: currentNode.current,
            data: currentNodeclickMapData.current,
            timespent: nodeTimeSpent.current,
        });
        if (location.pathname.substr(1, 1) === "t") {
            let data = Object.assign(
                {},
                { path_travelled: travelledPath.toString() }
            );
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;
            data["task_time_spent"] = taskTimeSpent;
            data["task_id"] = task.id;
            data["is_success"] =
                travelledPath[travelledPath.length - 1] ==
                    prototypeTask.goal_screen_node_id
                    ? 1
                    : 0;
            data["click_map_data"] = clickMapData.current;
            savePrototypeTesterInterctions(data, ReactSession.get("token")).then(
                (response) => {
                    setLoading(false);
                    if (response.success) {
                        // moveToNextTask(active_task + 1);
                        console.log("interactions saved");
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            // moveToNextTask(active_task + 1);
            console.log("interactions saved");
        }
    };

    window.addEventListener("message", receiveMessage, false);

    function receiveMessage(event) {
        var data = event.data;
        if (data.type == "MOUSE_PRESS_OR_RELEASE") {
            var clickednode = {
                x: Math.round(
                    data.data.nearestScrollingFrameOffset
                        ? data.data.nearestScrollingFrameOffset.x +
                        data.data.nearestScrollingFrameMousePosition.x
                        : data.data.targetNodeMousePosition.x
                ),
                y: Math.round(
                    data.data.nearestScrollingFrameOffset
                        ? data.data.nearestScrollingFrameOffset.y +
                        data.data.nearestScrollingFrameMousePosition.y
                        : data.data.targetNodeMousePosition.y
                ),
                value: 1,
            };
            if (currentNodeclickMapData.current.length == 0) {
                currentNodeclickMapData.current.push(clickednode);
            } else {
                if (
                    clickednode.x !=
                    currentNodeclickMapData.current[
                        currentNodeclickMapData.current.length - 1
                    ].x
                ) {
                    currentNodeclickMapData.current.push(clickednode);
                }
            }
        }

        if (data.type == "PRESENTED_NODE_CHANGED" && data.data.presentedNodeId) {
            if (travelledPath.current.length == 0) {
                travelledPath.current.push(data.data.presentedNodeId);
                currentNode.current = data.data.presentedNodeId;
            } else {
                if (
                    data.data.presentedNodeId !=
                    travelledPath.current[travelledPath.current.length - 1]
                ) {
                    travelledPath.current.push(data.data.presentedNodeId);
                    clickMapData.current.push({
                        node: currentNode.current,
                        data: currentNodeclickMapData.current,
                        timespent: nodeTimeSpent.current,
                    });
                    currentNode.current = data.data.presentedNodeId;
                    currentNodeclickMapData.current = [];
                    nodeTimeSpent.current = 0;
                }
            }
        }
    }

    const loadQuestions = () => {
        let Questions = [];

        isActiveQuestionId.current = null;

        if (questionType === "Survey") {
            if (test && task.prototype_test_task_question.length) {
                setActiveQuestion(1);
                setTotalQuestion(test && task.prototype_test_task_question.length);

                test &&
                    task.prototype_test_task_question.forEach((items) => {
                        Questions.push({
                            data: items,
                            questionData: JSON.parse(items.questions),
                        });
                        if (JSON.parse(items.questions)["is_logic"] == 1) {
                            setLogicAdded(true);
                        }
                    });

                setQuestionArrayList(Questions);
                isOptional.current = Questions[0]["questionData"]["is_optional"];
                const questionTypeData = Questions.filter(
                    (item, indexItem) => indexItem + 1 === 1
                )[0];
                if (questionTypeData.data.question_type === "singlechoice") {
                    setFormValues({
                        ...formValues,
                        type: "single",
                        is_optional: questionTypeData.questionData.is_optional,
                    });
                } else if (questionTypeData.data.question_type === "multiplechoice") {
                    setFormValues({
                        ...formValues,
                        type: "multiple",
                        is_optional: questionTypeData.questionData.is_optional,
                    });
                } else if (questionTypeData.data.question_type === "ratingscale") {
                    setFormValues({
                        ...formValues,
                        type: "ratingscale",
                        is_optional: questionTypeData.questionData.is_optional,
                    });
                } else if (questionTypeData.data.question_type === "likertscale") {
                    setFormValues({
                        ...formValues,
                        type: "likertscale",
                        is_optional: questionTypeData.questionData.is_optional,
                    });
                } else if (
                    questionTypeData.data.question_type === "likertscale_single"
                ) {
                    setFormValues({
                        ...formValues,
                        type: "likertscale_single",
                        is_optional: questionTypeData.questionData.is_optional,
                    });
                } else if (questionTypeData.data.question_type === "rankingscale") {
                    let ranking_options = Object.assign([], questionTypeData.data.prototypetestoptions);
                    if (
                        "randomize_ranking_options" in questionTypeData.questionData &&
                        questionTypeData.questionData.randomize_ranking_options == 1
                    ) {
                        ranking_options = shuffle(ranking_options);
                    }
                    setRankingOptions(ranking_options);

                    let options = [];
                    ranking_options.forEach((option) => {
                        options.push(option.id);
                    });

                    setFormValues({
                        ...formValues,
                        type: "rankingscale",
                        question_id: questionTypeData.data.id,
                        is_optional: questionTypeData.questionData.is_optional,
                        answer: "",
                        option_id: options,
                    });
                } else {
                    setFormValues({
                        ...formValues,
                        type: "free",
                        is_optional: questionTypeData.questionData.is_optional,
                    });
                }
            } else {
                saveQuestionData([], true);
            }
        }
    };

    const handleSubmitQuestion = (e) => {
        e.preventDefault(); // Prevent default form submission
        e.stopPropagation(); // Stop event propagation

        setFormErrors({ error: "", error_class: "" });
        if (isActiveQuestionId.current == null) {
            isActiveQuestionId.current = QuestionArrayList[0]["data"]["id"];
        }
        if (isSkipped.current == 0) {
            if (
                (formValues.is_optional == 1 &&
                    ((formValues.answer === "" &&
                        formValues.type !== "multiple" &&
                        formValues.type !== "rankingscale" &&
                        formValues.type !== "likertscale" &&
                        formValues.type !== "likertscale_single") ||
                        ((formValues.type === "multiple" ||
                            formValues.type === "rankingscale") &&
                            formValues.option_id.length === 0))) ||
                ((formValues.type === "likertscale" ||
                    formValues.type === "likertscale_single") &&
                    formValues.option_id.length === 0)
            ) {
                if (skippedCount.current < 2) {
                    if (
                        formValues.is_optional == 0 &&
                        (formValues.type == "likertscale" ||
                            formValues.type === "likertscale_single")
                    ) {
                        isSkipped.current = 0;
                    } else {
                        isSkipped.current = 1;
                        setFormValues({
                            ...formValues,
                            question_id: isActiveQuestionId.current,
                        });
                        skippedCount.current = skippedCount.current + 1;
                    }
                } else {
                    showToast("You can skip maximum of 2 questions.", "error");
                    return false;
                }
            }
        }

        if (isSkipped.current == 0) {
            if (
                formValues.answer === "" &&
                formValues.type !== "multiple" &&
                formValues.type !== "rankingscale" &&
                formValues.type !== "likertscale" &&
                formValues.type !== "likertscale_single"
            ) {
                setFormErrors({ error: "Required field", error_class: "input_error" });

                if (formValues.type === "single" || formValues.type === "ratingscale") {
                    showToast(
                        "You need to select one answer before moving to the next question.",
                        "error"
                    );
                }
                return false;
            }

            if (
                formValues.type === "rankingscale" &&
                formValues.option_id.length === 0
            ) {
                setFormErrors({ error: "Required field", error_class: "input_error" });
                showToast(
                    "You need to select one answer before moving to the next question.",
                    "error"
                );
                return false;
            }

            if (formValues.type === "multiple") {
                var mc_question = QuestionArrayList[isActiveQuestion - 1];

                let mc_error = false;

                let mc_error_message =
                    "You need to select at least 1 option before moving to the next question.";

                let other_form_error = false;

                let other_selected = false;

                formValues.option_id.forEach(function (option_id) {
                    if (QuestionArrayList[isActiveQuestion - 1].data.options) {
                        QuestionArrayList[isActiveQuestion - 1].data.options.forEach(
                            function (option) {
                                if (
                                    option.id == option_id &&
                                    ((test.language == "en" && option.option_value == "Other") ||
                                        (option.option_value == "آخر" && test.language == "ar"))
                                ) {
                                    other_selected = true;
                                }
                            }
                        );
                    }
                });
                if (isNoneOfTheAboveSelected) {
                    mc_error = false;
                } else if (other_selected && !formValues.other_option_value) {
                    other_form_error = true;

                    mc_error = true;
                } else {
                    if (mc_question.questionData) {
                        var mc_question_data = mc_question.questionData;

                        if (mc_question_data) {
                            if (mc_question_data.exact) {
                                if (!(formValues.option_id.length == mc_question_data.exact)) {
                                    mc_error = true;

                                    mc_error_message = "You need to select " + mc_question_data.exact + " options.";
                                }
                            } else if (mc_question_data.min && mc_question_data.max) {
                                if (
                                    !(
                                        formValues.option_id.length >= mc_question_data.min &&
                                        formValues.option_id.length <= mc_question_data.max
                                    )
                                ) {
                                    mc_error = true;

                                    if (formValues.option_id.length < mc_question_data.min) {
                                        mc_error_message = "You need to select at least " + mc_question_data.min + " options before moving to the next question.";
                                    } else {
                                        mc_error_message = "You can select up to " + mc_question_data.max + " options.";
                                    }
                                }
                            } else if (mc_question_data.min) {
                                if (!(formValues.option_id.length >= mc_question_data.min)) {
                                    mc_error = true;

                                    mc_error_message = "You need to select at least " + mc_question_data.min + " options before moving to the next question.";
                                }
                            } else if (mc_question_data.max) {
                                if (!(formValues.option_id.length <= mc_question_data.max)) {
                                    mc_error = true;

                                    mc_error_message = "You can select up to " + mc_question_data.max + " options.";
                                }
                            } else {
                                if (formValues.option_id.length === 0) {
                                    mc_error = true;

                                    mc_error_message = "You need to select one answer before moving to the next question.";

                                }
                            }
                        } else {
                            if (formValues.option_id.length === 0) {
                                mc_error = true;

                                mc_error_message = "You need to select at least 1 option before moving to the next question.";

                            }
                        }
                    } else {
                        if (formValues.option_id.length === 0) {
                            mc_error = true;

                            mc_error_message = "You need to select at least 1 option before moving to the next question.";

                        }
                    }
                }

                if (mc_error) {
                    if (other_form_error) {
                        //showToast("", "error");
                        setFormErrors({
                            error: "Required field",
                            error_class: "input_error",
                        });
                    } else {
                        showToast(mc_error_message, "error");
                    }
                    return false;
                }
            }

            if (formValues.type === "rankingscale" && !nextButtonActive.current) {
                return false;
            }
            if (
                (formValues.type === "likertscale" || formValues.type === "likertscale_single") &&
                formValues.option_id.length === 0
            ) {
                setFormErrors({ error: "Required field", error_class: "input_error" });
                showToast(
                    "You need to answer before moving to the next question.",
                    "error"
                );
                return false;
            } else {
                if (formValues.option_id.length < formValues.totalSubQuestions) {
                    setFormErrors({
                        error: "Required field",
                        error_class: "input_error",
                    });
                    showToast("You need to answer for each subquestion.", "error");
                    return false;
                }
            }
            var other_selected = false;
            {
                /*
                
                            if((formValues.type === "multiple") ){
                                formValues.option_id.forEach(function(option_id){
                
                                    if(QuestionArrayList[isActiveQuestion-1].data.prototypetestoptions){
                                        
                                        QuestionArrayList[isActiveQuestion-1].data.prototypetestoptions.forEach(function(option){
                                            if(option.id == option_id && ((test.language == "en" && option.option_value == "Other") || (option.option_value == "آخر" && test.language == "ar"))){
                                                other_selected = true;
                                            }
                                        });
                                    }
                                });
                            }
                                */
            }
            if (formValues.type === "single") {
                if (
                    QuestionArrayList[isActiveQuestion - 1].data.prototypetestoptions &&
                    formValues.answer
                ) {
                    QuestionArrayList[
                        isActiveQuestion - 1
                    ].data.prototypetestoptions.forEach(function (option) {
                        if (
                            option.id == formValues.answer &&
                            ((test.language == "en" && option.option_value == "Other") ||
                                (option.option_value == "آخر" && test.language == "ar"))
                        ) {
                            other_selected = true;
                        }
                    });
                }
            }
            if (
                formValues.type === "single" &&
                other_selected &&
                formValues.other_option_value == ""
            ) {
                setFormErrors({ error: "Required field", error_class: "input_error" });
                return false;
            }
        }

        // location scroll top
        if (isActiveQuestion < totalQuestion) {
            window.scrollTo(0, 0);
        }
        // check & activate next question
        formValues["question_time_spent"] = questionTimeSpend;
        formValues["is_skipped"] = isSkipped.current;
        if (isActiveQuestionId.current && logicalySkipped.current == "0") {
            formValues["question_id"] = isActiveQuestionId.current;
        }
        setQuestionTimeSpend(0);
        setQuestionArray([...questionArray, formValues]); // set data in array & make form value blank
        if (isActiveQuestion < totalQuestion) {
            var nextquestioncount = 1;
            if (formValues.type == "single") {
                const currentquestionData = QuestionArrayList.filter(
                    (item, indexItem) => indexItem + 1 === isActiveQuestion
                )[0];

                if (formValues.answer != "") {
                    const chosenoption =
                        currentquestionData.data.prototypetestoptions.filter(
                            (item) => item.id == formValues.answer
                        )[0];

                    if (chosenoption.jump_to_question == "End Survey") {
                        saveQuestionData([...questionArray, formValues], false);
                        return false;
                    } else if (chosenoption.jump_to_question != null) {
                        const jumpToQuestion = parseInt(chosenoption.jump_to_question);
                        nextquestioncount = jumpToQuestion - isActiveQuestionId.current;
                        logicalySkipped.current = 1;
                    }
                }
            } else {
                const currentquestionData = QuestionArrayList.filter(
                    (item, indexItem) => indexItem + 1 === isActiveQuestion
                )[0];

                if (currentquestionData.questionData["is_logic"] == 1) {
                    if (currentquestionData.data.jump_to_question == "End Survey") {
                        saveQuestionData([...questionArray, formValues], false);
                        return false;
                    } else if (currentquestionData.data.jump_to_question != null) {
                        const jumpToQuestion = parseInt(
                            currentquestionData.data.jump_to_question
                        );
                        nextquestioncount = jumpToQuestion - isActiveQuestion;
                        logicalySkipped.current = 1;
                    }
                }
            }

            const questionTypeData = QuestionArrayList.filter(
                (item, indexItem) =>
                    indexItem + 1 === isActiveQuestion + nextquestioncount
            )[0];

            if (questionTypeData.data.question_type === "singlechoice") {
                var types = "single";
            } else if (questionTypeData.data.question_type === "multiplechoice") {
                var types = "multiple";
            } else if (questionTypeData.data.question_type === "ratingscale") {
                var types = "ratingscale";
            } else if (questionTypeData.data.question_type === "likertscale") {
                var types = "likertscale";
            } else if (questionTypeData.data.question_type === "likertscale_single") {
                var types = "likertscale_single";
            } else if (questionTypeData.data.question_type === "rankingscale") {
                var types = "rankingscale";
            } else {
                var types = "free";
            }

            let options = [];
            if (types == "rankingscale") {
                
                isActiveQuestionId.current = questionTypeData.data.id;
                let ranking_options = Object.assign([], questionTypeData.data.prototypetestoptions);
                if ('randomize_ranking_options' in questionTypeData.questionData && questionTypeData.questionData.randomize_ranking_options == 1) {
                    ranking_options = shuffle(ranking_options)
                }

                setRankingOptions(ranking_options);

                let options = [];
                ranking_options.forEach((option) => {
                    options.push(option.id);
                });

                setFormValues({
                    type: types,
                    question_id: questionTypeData.data.id,
                    is_optional: questionTypeData.questionData.is_optional,
                    answer: "",
                    option_id: options,
                });
            } else {
                setFormValues({
                    type: types,
                    question_id: null,
                    is_optional: questionTypeData.questionData.is_optional,
                    answer: "",
                    option_id: [],
                });
            }

            setActiveQuestion(isActiveQuestion + nextquestioncount);
            logicalySkipped.current = 0;
            otherOptionSelected.current = false;
            likertAttemptedSubQuestion.current = 0;
            setOptions([]);
            isSkipped.current = 0;
            if (types !== "rankingscale") {
                isActiveQuestionId.current =
                    QuestionArrayList[isActiveQuestion]["data"]["id"];
                nextButtonActive.current = false;
            } else {
                nextButtonActive.current = false;
            }
            isOptional.current =
                QuestionArrayList[isActiveQuestion]["questionData"]["is_optional"];
        } else {
            saveQuestionData([...questionArray, formValues], false);
            saveTesterInteraction(travelledPath.current);
        }
    };

    const saveQuestionData = (formData, shouldNavigate) => {
        if (location.pathname.substr(1, 1) === "t") {
            let data = Object.assign({}, { questions: formData });
            data["test_id"] = result && result.test_id;
            data["result_id"] = result && result.id;
            data["question_type"] = questionType;
            data["task_id"] = task.id;
            data["guest_token"] = ReactSession.get("guest_token");
            data["time_spent"] = timeSpent;

            // cannot hit api multiple time if already running api request
            if (questionLoading) {
                return false;
            }

            if (!shouldNavigate) {
                setQuestionLoading(true);
            }

            if (shouldNavigate) {
                // Only move to next task if we're on the last question
                if (isActiveQuestion >= totalQuestion) {
                    moveToNextTask(active_task + 1);
                }
                return;
            }

            savePrototypeResultQuestion(data, ReactSession.get("token")).then(
                (response) => {
                    if (!shouldNavigate) {
                        setQuestionLoading(false);
                    }
                    if (response.success) {
                        setFormValues({
                            type: null,
                            question_id: null,
                            answer: "",
                            option_id: [],
                            is_optional: 0,
                        });
                        // Only move to next task if we're on the last question
                        if (isActiveQuestion >= totalQuestion) {
                            moveToNextTask(active_task + 1);
                        }
                    } else {
                        showToast(response.message, "error");
                    }
                }
            );
        } else {
            setFormValues({
                type: null,
                question_id: null,
                answer: "",
                option_id: [],
                is_optional: 0,
            });
            // Only move to next task if we're on the last question
            if (isActiveQuestion >= totalQuestion) {
                moveToNextTask(active_task + 1);
            }
        }
    };
    const movetonextlikertsubquestion = (subquestionindex) => {
        setLikertActive(true);
        var nextquestionid = "subquestion-" + parseInt(subquestionindex + 1, 10);
        const item = document.getElementById(nextquestionid);
        item.scrollIntoView({
            behavior: "smooth",
            block: "center",
        });
    };

    const handleDragStart = (event) => {
        const draggedDOM = getDraggedDom(event.draggableId);

        if (!draggedDOM) {
            return;
        }

        const { clientHeight, clientWidth } = draggedDOM;
        const sourceIndex = event.source.index;
        var clientY =
            parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
            [...draggedDOM.parentNode.children]
                .slice(0, sourceIndex)
                .reduce((total, curr) => {
                    const style = curr.currentStyle || window.getComputedStyle(curr);
                    const marginBottom = parseFloat(style.marginBottom);
                    return total + curr.clientHeight + marginBottom;
                }, 0);

        setPlaceholderProps({
            clientHeight,
            clientWidth,
            clientY,
            clientX: parseFloat(
                window.getComputedStyle(draggedDOM.parentNode).paddingLeft
            ),
            background: "#CCCCCC",
            border: "none",
        });
    };

    const handleDragUpdate = (event) => {
        if (!event.destination) {
            return;
        }

        const draggedDOM = getDraggedDom(event.draggableId);

        if (!draggedDOM) {
            return;
        }

        const { clientHeight, clientWidth } = draggedDOM;
        const destinationIndex = event.destination.index;

        const sourceIndex = event.source.index;

        const childrenArray = [...draggedDOM.parentNode.children];
        const movedItem = childrenArray[sourceIndex];
        childrenArray.splice(sourceIndex, 1);

        const updatedArray = [
            ...childrenArray.slice(0, destinationIndex),
            movedItem,
            ...childrenArray.slice(destinationIndex + 1),
        ];

        var clientY =
            parseFloat(window.getComputedStyle(draggedDOM.parentNode).paddingTop) +
            updatedArray.slice(0, destinationIndex).reduce((total, curr) => {
                const style = curr.currentStyle || window.getComputedStyle(curr);
                const marginBottom = parseFloat(style.marginBottom);
                return total + curr.clientHeight + marginBottom;
            }, 0);

        setPlaceholderProps({
            clientHeight,
            clientWidth,
            clientY,
            clientX: parseFloat(
                window.getComputedStyle(draggedDOM.parentNode).paddingLeft
            ),
            background: "none",
            border: "1px dashed",
        });
    };

    const updateNextBtnStateThruOptions = (
        items,

        formValues,

        isNoneOfTheAbove
    ) => {
        let next_btn_active = false;
        let other_selected = false;

        formValues.option_id.forEach(function (option_id) {
            if (QuestionArrayList[isActiveQuestion - 1].data.surveyoptions) {
                QuestionArrayList[isActiveQuestion - 1].data.surveyoptions.forEach(
                    function (option) {
                        if (
                            option.id == option_id &&
                            ((test.language == "en" && option.option_value == "Other") ||
                                (option.option_value == "آخر" && test.language == "ar"))
                        ) {
                            other_selected = true;
                        }
                    }
                );
            }
        });

        if (isNoneOfTheAbove) {
            next_btn_active = true;
        } else if (other_selected && !formValues.other_option_value) {
            next_btn_active = false;
        } else {
            if (items.questionData) {
                if (items.questionData.exact) {
                    if (formValues.option_id.length == items.questionData.exact) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else if (items.questionData.min && items.questionData.max) {
                    if (
                        formValues.option_id.length >= items.questionData.min &&
                        formValues.option_id.length <= items.questionData.max
                    ) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else if (items.questionData.min) {
                    if (formValues.option_id.length >= items.questionData.min) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else if (items.questionData.max) {
                    if (formValues.option_id.length <= items.questionData.max) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else {
                    if (formValues.option_id.length > 0) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                }
            } else {
                if (formValues.option_id.length > 0) {
                    next_btn_active = true;
                }
            }
        }

        nextButtonActive.current = next_btn_active;
    };

    const updateNextBtnStateThruOther = (items, formValues) => {
        let next_btn_active = false;

        if (isNoneOfTheAboveSelected) {
            next_btn_active = true;
        } else if (!formValues.other_option_value) {
            next_btn_active = false;
        } else {
            if (items.questionData) {
                if (items.questionData.exact) {
                    if (formValues.option_id.length == items.questionData.exact) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else if (items.questionData.min && items.questionData.max) {
                    if (
                        formValues.option_id.length >= items.questionData.min &&
                        formValues.option_id.length <= items.questionData.max
                    ) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else if (items.questionData.min) {
                    if (formValues.option_id.length >= items.questionData.min) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else if (items.questionData.max) {
                    if (formValues.option_id.length <= items.questionData.max) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                } else {
                    if (formValues.option_id.length > 0) {
                        next_btn_active = true;
                    } else {
                        next_btn_active = false;
                    }
                }
            } else {
                if (formValues.option_id.length > 0) {
                    next_btn_active = true;
                }
            }
        }

        nextButtonActive.current = next_btn_active;
    };

    const getDraggedDom = (draggableId) => {
        const domQuery = `[${queryAttr}='${draggableId}']`;
        const draggedDOM = document.querySelector(domQuery);

        return draggedDOM;
    };

    const runFunction = (e) => {
        if (e.target.type == "text" || e.target.type == "textarea") {
            // e.preventDefault();
            return;
        } else {
            // e.preventDefault();
            isTyping.current = false;
            return;
        }
    };
    const [showNav, setShowNav] = useState(false);
    const showRef = useRef(null);

    const toggleNav = () => {
        setShowNav(!showNav);
    };

    // Modify the render function to use GlobalQuestion
    const renderQuestion = () => {
        if (!task || !task.prototype_test_task_question || task.prototype_test_task_question.length === 0) {
            return null;
        }

        const currentQuestion = QuestionArrayList[isActiveQuestion - 1];
        if (!currentQuestion) {
            return null;
        }

        return (
            <GlobalQuestion
                test={test}
                question={currentQuestion}
                currentStep={isActiveQuestion}
                totalSteps={totalQuestion}
                onNext={(formData, shouldNavigate, jumpToQuestion) => {
                    saveQuestionData(formData, shouldNavigate, jumpToQuestion);
                }}
                onSkip={() => {
                    if (skippedCount.current < 2) {
                        isSkipped.current = 1;
                        saveQuestionData({
                            type: null,
                            question_id: isActiveQuestionId.current,
                            answer: "",
                            option_id: [],
                            is_optional: 0,
                        });
                        skippedCount.current += 1;
                    }
                }}
                isOptional={currentQuestion.questionData.is_optional}
                timeSpent={questionTimeSpend}
                questionType={currentQuestion.data.question_type}
                result={result}
                methodology="prototype"
                isPrototypeTest={true}
                prototypeTask={task}
                onBackToExplore={() => {
                    // Handle back to explore functionality
                    if (isTyping.current) {
                        isTyping.current = false;
                    }
                    setQuestionsSidebarOpen(false);
                    setFormValues({
                        ...formValues,
                        answer: "",
                        option_id: [],
                    });
                }}
            />
        );
    };

    const handleNextQuestion = (formData) => {
        if (isActiveQuestion < totalQuestion) {
            // Save current question data
            setQuestionArray([...questionArray, formData]);

            // Move to next question
            setActiveQuestion(isActiveQuestion + 1);

            // Reset form values for next question
            setFormValues({
                type: null,
                question_id: null,
                answer: "",
                option_id: [],
                is_optional: 0,
            });

            // Reset other states
            isSkipped.current = 0;
            logicalySkipped.current = 0;
            otherOptionSelected.current = false;
            likertAttemptedSubQuestion.current = 0;
            setOptions([]);
            nextButtonActive.current = false;

            // Scroll to top
            window.scrollTo(0, 0);
        } else {
            // If it's the last question, save and move to next task
            saveQuestionData([...questionArray, formData], false);
            saveTesterInteraction(travelledPath.current);
        }
    };

    return (
        <div className="tester-page-wrapper tester-welcome-page-wrap tester-test-intro figma-mobile-prototype">
            <div className="prototype-test-wrap five-second-full-view-wrap prototype-test-fullscreen">
                {loading ? (
                    <div className="loader_section full-page-loader prototype-loader">
                        <LoadingIcon />
                    </div>
                ) : (
                    <>
                        {sidebarOpen && (
                            <>
                                <div className="figma_prototype_sidebar prototypesidebar">
                                    <div className="sidebar-header">
                                        {test.language == "ar" ? (
                                            <div
                                                onClick={() => {
                                                    setOpenExitTestModal(true);
                                                }}
                                                className="exit-test-button"
                                            >
                                                <Text type="body-text-3" fontWeight="medium-font">
                                                    {" "}
                                                    {test.language == "ar" ? <>اخرج</> : <>Exit test</>}
                                                </Text>
                                                <Icon
                                                    colorClass={"gray-900-svg"}
                                                    value="back-arrow"
                                                    size={"small"}
                                                />
                                            </div>
                                        ) : (
                                            <div
                                                onClick={() => {
                                                    setOpenExitTestModal(true);
                                                }}
                                                className="exit-test-button"
                                            >
                                                <Icon
                                                    colorClass={"gray-900-svg"}
                                                    value="back-arrow"
                                                    size={"small"}
                                                />
                                                <Text type="body-text-3" fontWeight="medium-font">
                                                    {" "}
                                                    {test.language == "ar" ? <>اخرج</> : <>Exit test</>}
                                                </Text>
                                            </div>
                                        )}
                                        <div className="contact-support-button">
                                            {user && user.role == "Tester" ? (
                                                <div
                                                    onClick={() => {
                                                        navigate(
                                                            "/t/support/contact?reason=Problem with the platform"
                                                        );
                                                    }}
                                                >
                                                    <Text type="body-text-3" fontWeight="medium-font">
                                                        {test.language == "ar" ? (
                                                            <>اتصل بالدعم</>
                                                        ) : (
                                                            <>Contact support</>
                                                        )}
                                                    </Text>
                                                </div>
                                            ) : (
                                                <>
                                                    {user && user.role == "Researcher" ? (
                                                        <div
                                                            onClick={() => {
                                                                navigate("/r/support/contact");
                                                            }}
                                                        >
                                                            <Text type="body-text-3" fontWeight="medium-font">
                                                                {test.language == "ar" ? (
                                                                    <>اتصل بالدعم</>
                                                                ) : (
                                                                    <>Contact support</>
                                                                )}
                                                            </Text>
                                                        </div>
                                                    ) : (
                                                        <a
                                                            href={"https://userq.com/contact-us/"}
                                                            target={"_blank"}
                                                            className="contact-support-guestuser"
                                                        >
                                                            <div onClick={() => { }}>
                                                                <Text
                                                                    type="body-text-3"
                                                                    fontWeight="medium-font"
                                                                >
                                                                    {test.language == "ar" ? (
                                                                        <>اتصل بالدعم</>
                                                                    ) : (
                                                                        <>Contact support</>
                                                                    )}
                                                                </Text>
                                                            </div>
                                                        </a>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                        <div
                                            className="minimie-screen-icon"
                                            onClick={() => {
                                                setSidebarOpen(false);
                                                setGetStarted(false);
                                            }}
                                        >
                                            <Icon
                                                value="Minimize cards"
                                                size={"small"}
                                                hover={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="figma_prototype_sidebar_body">
                                        <div className="figma-prototype-sidebar-body-inner">
                                            <Text type="h3">
                                                {test.language == "ar" ? "التعليمات" : "Instructions"}
                                            </Text>
                                            <Text type="body-text-2" fontWeight="medium-font">
                                                {task.description}
                                            </Text>
                                            {getStarted ? (
                                                <>
                                                    {test.language == "ar" ? (
                                                        <>
                                                            {currentNode.current == null ? (
                                                                <Button
                                                                    type={"primary"}
                                                                    size="large"
                                                                    onClick={() => {
                                                                        // setSidebarOpen(false);
                                                                        // setGetStarted(false);
                                                                    }}
                                                                    label="جاري تحميل النموذج المبدئي"
                                                                    microLoading={true}
                                                                />
                                                            ) : (
                                                                <Button
                                                                    type={"primary"}
                                                                    size="large"
                                                                    onClick={() => {
                                                                        setSidebarOpen(false);
                                                                        setGetStarted(false);
                                                                        nodeTimeSpent.current = 0;
                                                                    }}
                                                                    label="لنبدأ"
                                                                    iconRight={
                                                                        <Icon
                                                                            colorClass={"gray-50-svg"}
                                                                            value={"back-arrow"}
                                                                            size="medium"
                                                                        />
                                                                    }
                                                                />
                                                            )}
                                                        </>
                                                    ) : (
                                                        <>
                                                            {currentNode.current == null ? (
                                                                <div className="loading-prototype-button">
                                                                    <Button
                                                                        type={"primary"}
                                                                        size="large"
                                                                        onClick={() => {
                                                                            // setSidebarOpen(false);
                                                                            // setGetStarted(false);
                                                                        }}
                                                                        label="Loading prototype"
                                                                        microLoading={true}
                                                                    />
                                                                </div>
                                                            ) : (
                                                                <Button
                                                                    type={"primary"}
                                                                    size="large"
                                                                    onClick={() => {
                                                                        setSidebarOpen(false);
                                                                        setGetStarted(false);
                                                                        nodeTimeSpent.current = 0;
                                                                    }}
                                                                    label="Get started"
                                                                    iconRight={
                                                                        <Icon
                                                                            colorClass={"gray-50-svg"}
                                                                            value={"forward-arrow"}
                                                                            size="medium"
                                                                        />
                                                                    }
                                                                />
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            ) : (
                                                <div className="free-flow-task-flow">
                                                    <Button
                                                        type={"secondary"}
                                                        size="large"
                                                        onClick={() => {
                                                            setSidebarOpen(false);
                                                        }}
                                                        label={
                                                            test.language == "ar"
                                                                ? "استمر في الاستكشاف"
                                                                : "Keep exploring"
                                                        }
                                                    />
                                                    {test.language == "ar" ? (
                                                        <Button
                                                            type={"primary"}
                                                            size="large"
                                                            onClick={() => {
                                                                setSidebarOpen(false);
                                                                setQuestionsSidebarOpen(true);
                                                            }}
                                                            label="أنا جاهز للإجابة"
                                                            iconRight={
                                                                <Icon
                                                                    colorClass={"gray-50-svg"}
                                                                    value={"back-arrow"}
                                                                    size="medium"
                                                                />
                                                            }
                                                        />
                                                    ) : (
                                                        <Button
                                                            type={"primary"}
                                                            size="large"
                                                            onClick={() => {
                                                                setSidebarOpen(false);
                                                                setQuestionsSidebarOpen(true);
                                                            }}
                                                            label="I'm ready to answer"
                                                            iconRight={
                                                                <Icon
                                                                    colorClass={"gray-50-svg"}
                                                                    value={"forward-arrow"}
                                                                    size="medium"
                                                                />
                                                            }
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        <div
                            className={`figma_prototype_design_screen_container ${sidebarOpen || questionsSidebarOpen
                                ? "prototype-overlay-class"
                                : ""
                                }`}
                        >
                            <div className="figma_prototype_design_screen">
                                <div
                                    id="heatmapContainer"
                                    className="prototype-iframe-overlay"
                                ></div>
                                <div id="prototype-iframe">
                                    <iframe
                                        id="figma_prototype_iframe"
                                        height="450"
                                        width="800"
                                        src={
                                            "https://embed.figma.com/proto/" +
                                            prototypeTask.file_key +
                                            "/" +
                                            prototypeTask.figma_filename +
                                            "?node-id=" +
                                            prototypeTask.start_screen_node_id +
                                            "&version-id=" +
                                            prototypeTask.version +
                                            "&starting-point-node-id=" +
                                            prototypeTask.start_screen_node_id +
                                            "&hide-ui=1&hotspot-hints=0&scaling=scale-down-width&disable-default-keyboard-nav=1&embed-host=userq&client-id=" +
                                            process.env.REACT_APP_FIGMA_CLIENT_ID
                                        }
                                        allowFullScreen
                                    />
                                </div>
                            </div>
                            <div
                                className="open-nav-btn none-for-desktop"
                                onClick={toggleNav}
                            >
                                <span>
                                    <Icon value={"menu"} size={"medium"} color={"gray-50-svg"} />
                                </span>
                            </div>
                            {!(sidebarOpen || questionsSidebarOpen) && (
                                <>
                                    {showNav && (
                                        <div
                                            ref={showRef}
                                            className="figma_prototype_footer prototype-footer-mobile"
                                        >
                                            <div className="prototype-figma-footer-data none-for-desktop">
                                                <div className="close-nav" onClick={toggleNav}>
                                                    <Icon value={"close"} size={"medium"} />
                                                </div>
                                                <Text type="caption">
                                                    {test.language == "ar"
                                                        ? 'راجع التعليمات وتصفح النموذج الأولي. انقر فوق "أنا جاهز للإجابة" عندما تكون مستعدًا للإجابة على الأسئلة.'
                                                        : `Review the instructions and explore the prototype. Click "I'm ready to answer" when you are ready.`}
                                                </Text>

                                                {test.language == "ar" ? (
                                                    <Button
                                                        type={"secondary"}
                                                        size={"large"}
                                                        onClick={() => {
                                                            if (currentNode.current != null) {
                                                                setSidebarOpen(true);
                                                                toggleNav();
                                                            }
                                                        }}
                                                        label="اقرأ التعليمات"
                                                        iconLeft={<Icon value={"eye"} size="medium" />}
                                                        state={
                                                            currentNode.current == null ? "disabled" : ""
                                                        }
                                                    />
                                                ) : (
                                                    <Button
                                                        type={"secondary"}
                                                        size={"large"}
                                                        onClick={() => {
                                                            if (currentNode.current != null) {
                                                                setSidebarOpen(true);
                                                                toggleNav();
                                                            }
                                                        }}
                                                        label="Read the instructions"
                                                        iconLeft={<Icon value={"eye"} size="medium" />}
                                                        state={
                                                            currentNode.current == null ? "disabled" : ""
                                                        }
                                                    />
                                                )}

                                                <Button
                                                    type={"primary"}
                                                    size={"large"}
                                                    onClick={() => {
                                                        if (currentNode.current != null) {
                                                            setQuestionsSidebarOpen(true);
                                                            toggleNav();
                                                            if (questionsOpened.current == false) {
                                                                setQuestionTimeSpend(0);
                                                                questionsOpened.current = true;
                                                            }
                                                        }
                                                    }}
                                                    label={
                                                        test.language == "ar"
                                                            ? "أنا جاهز للإجابة"
                                                            : "I'm ready to answer"
                                                    }
                                                    state={
                                                        currentNode.current == null ? "disabled" : "active"
                                                    }
                                                />
                                            </div>
                                        </div>
                                    )}
                                    <div className="figma_prototype_footer none-for-mobile">
                                        {test.language == "ar" ? (
                                            <Button
                                                type={"secondary"}
                                                onClick={() => {
                                                    if (currentNode.current != null) {
                                                        setSidebarOpen(true);
                                                    }
                                                }}
                                                label="اقرأ التعليمات"
                                                iconLeft={<Icon value={"eye"} size="medium" />}
                                                state={currentNode.current == null ? "disabled" : ""}
                                            />
                                        ) : (
                                            <Button
                                                type={"secondary"}
                                                onClick={() => {
                                                    if (currentNode.current != null) {
                                                        setSidebarOpen(true);
                                                    }
                                                }}
                                                label="Read the instructions"
                                                iconLeft={<Icon value={"eye"} size="medium" />}
                                                state={currentNode.current == null ? "disabled" : ""}
                                            />
                                        )}
                                        <Text type="caption">
                                            {test.language == "ar"
                                                ? 'راجع التعليمات وتصفح النموذج الأولي. انقر فوق "أنا جاهز للإجابة" عندما تكون مستعدًا للإجابة على الأسئلة.'
                                                : `Review the instructions and explore the prototype. Click "I'm ready to answer" when you are ready.`}
                                        </Text>
                                        <Button
                                            type={"primary"}
                                            onClick={() => {
                                                if (currentNode.current != null) {
                                                    setQuestionsSidebarOpen(true);
                                                    if (questionsOpened.current == false) {
                                                        setQuestionTimeSpend(0);
                                                        questionsOpened.current = true;
                                                    }
                                                }
                                            }}
                                            label={
                                                test.language == "ar"
                                                    ? "أنا جاهز للإجابة"
                                                    : "I'm ready to answer"
                                            }
                                            state={
                                                currentNode.current == null ? "disabled" : "active"
                                            }
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        {questionsSidebarOpen && (
                            <div
                                className={`figma_prototype_sidebar questions-sidebar ${formValues.type == "likertscale" ||
                                    formValues.type == "likertscale_single"
                                    ? "likert-question-wrap"
                                    : ""
                                    }`}
                            >
                                <div className="prototype-take-test-top-hdr">
                                    <div
                                        onClick={() => {
                                            setOpenExitTestModal(true);
                                        }}
                                        className="exit-test-button"
                                    >
                                        <Icon
                                            colorClass={"gray-900-svg"}
                                            value="back-arrow"
                                            size={"small"}
                                        />
                                        <Text type="body-text-3" fontWeight="medium-font">
                                            {" "}
                                            {test.language == "ar" ? <>اخرج</> : <>Exit test</>}
                                        </Text>
                                    </div>
                                    <div className="contact-support-button">
                                        {user && user.role == "Tester" ? (
                                            <div
                                                onClick={() => {
                                                    navigate(
                                                        "/t/support/contact?reason=Problem with the platform"
                                                    );
                                                }}
                                            >
                                                <Text type="body-text-3" fontWeight="medium-font">
                                                    {test.language == "ar" ? (
                                                        <>اتصل بالدعم</>
                                                    ) : (
                                                        <>Contact support</>
                                                    )}
                                                </Text>
                                            </div>
                                        ) : (
                                            <>
                                                {user && user.role == "Researcher" ? (
                                                    <div
                                                        onClick={() => {
                                                            navigate("/r/support/contact");
                                                        }}
                                                    >
                                                        <Text type="body-text-3" fontWeight="medium-font">
                                                            {test.language == "ar" ? (
                                                                <>اتصل بالدعم</>
                                                            ) : (
                                                                <>Contact support</>
                                                            )}
                                                        </Text>
                                                    </div>
                                                ) : (
                                                    <a
                                                        href={"https://userq.com/contact-us/"}
                                                        target={"_blank"}
                                                        className="contact-support-guestuser"
                                                    >
                                                        <div onClick={() => { }}>
                                                            <Text type="body-text-3" fontWeight="medium-font">
                                                                {test.language == "ar" ? (
                                                                    <>اتصل بالدعم</>
                                                                ) : (
                                                                    <>Contact support</>
                                                                )}
                                                            </Text>
                                                        </div>
                                                    </a>
                                                )}
                                            </>
                                        )}
                                    </div>
                                    <div
                                        className="minimie-screen-icon"
                                        onClick={() => {
                                            setQuestionsSidebarOpen(false);
                                        }}
                                    >
                                        <Icon
                                            colorClass="gray-900-svg"
                                            value="Minimize cards"
                                            size={"small"}
                                            hover={true}
                                        />
                                    </div>
                                </div>

                                <div className="figma_prototype_sidebar_body">
                                    <div className="taking-test-page-wrap">
                                        <div id="free-flow-wrapper" className="container-1">
                                            {QuestionArrayList &&
                                                QuestionArrayList.map((items, index) => {
                                                    return (
                                                        <div
                                                            className={`full ${items.questionData.questionType ===
                                                                "likertscale" ||
                                                                items.questionData.questionType ===
                                                                "likertscale_single"
                                                                ? ""
                                                                : ""
                                                                }`}
                                                            key={index}
                                                        >
                                                            {isActiveQuestion === index + 1 && (
                                                                <div className="full" key={index}>
                                                                    <GlobalQuestion
                                                                        test={test}
                                                                        question={items}
                                                                        currentStep={isActiveQuestion}
                                                                        totalSteps={totalQuestion}
                                                                        onNext={handleNextQuestion}
                                                                        onSkip={() => {
                                                                            if (skippedCount.current < 2) {
                                                                                isSkipped.current = 1;
                                                                                handleNextQuestion({
                                                                                    type: null,
                                                                                    question_id:
                                                                                        isActiveQuestionId.current,
                                                                                    answer: "",
                                                                                    option_id: [],
                                                                                    is_optional: 0,
                                                                                    is_skipped: 1,
                                                                                });
                                                                                skippedCount.current += 1;
                                                                            } else {
                                                                                showToast(
                                                                                    "You can skip maximum of 2 questions.",
                                                                                    "error"
                                                                                );
                                                                            }
                                                                        }}
                                                                        isOptional={items.questionData.is_optional}
                                                                        timeSpent={questionTimeSpend}
                                                                        questionType={items.data.question_type}
                                                                        result={result}
                                                                        methodology="prototype"
                                                                        isPrototypeTest={true}
                                                                        prototypeTask={task}
                                                                        onBackToExplore={() => {
                                                                            setQuestionsSidebarOpen(false);
                                                                            setFormValues({
                                                                                ...formValues,
                                                                                answer: "",
                                                                                option_id: [],
                                                                            });
                                                                        }}
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
            <ExitTestModal
                cssClass={
                    document.body.clientWidth > 767 &&
                        test.device === "mobile" &&
                        location.pathname.substr(1, 1) === "p" &&
                        test.methodology === "Prototype test"
                        ? "prototype-test-preview-for-desktop-mode-modal"
                        : ""
                }
                openExitTestModal={openExitTestModal}
                closeExitTestModal={closeExitTestModal}
                test={test}
                isPaidUser={isPaidUser}
            />
        </div>
    );
}
